import { Link } from "react-router-dom";
import { Nav, Navbar, Container } from "react-bootstrap";
import { useAuthState } from "../context/AuthContext";
import { Fragment } from "react";

const NaviItemLink = ({ path, name }) => {
  return (
    <Nav.Item>
      <Nav.Link as={Link} to={path}>
        {name}
      </Nav.Link>
    </Nav.Item>
  );
};

const TopNavBar = () => {
  const {
    loggedIn,
    loggedUser: { roler, displayName },
  } = useAuthState();

  return (
    <Container fluid="md">
      <Navbar variant="light" bg="light" expand="md">
        <Navbar.Brand href="#"></Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav defaultActiveKey="/" className="me-auto">
            <NaviItemLink path="/" name="홈" />
            {/* <NaviItemLink path="/test" name="테스트" /> */}
            {loggedIn ? (
              <Fragment>
                {roler === "admin" ? (
                  <Fragment>
                    <NaviItemLink path="/accounts" name="계정" />
                    <NaviItemLink path="/quests" name="퀘스트" />
                    <NaviItemLink path="/professors" name="교수" />
                    <NaviItemLink path="/students" name="학생" />
                    <NaviItemLink path="/courses" name="수업" />
                    <NaviItemLink path="/assessments" name="평가" />
                    <NaviItemLink path="/dsu-link" name="연동" />
                  </Fragment>
                ) : undefined}
                {roler === "tester" ? (
                  <Fragment>
                    <NaviItemLink path="/professors" name="교수" />
                    <NaviItemLink path="/students" name="학생" />
                    <NaviItemLink path="/courses" name="수업" />
                    <NaviItemLink path="/assessments" name="평가" />
                  </Fragment>
                ) : undefined}
                {roler === "professor" ? (
                  <Fragment>
                    <NaviItemLink path="/accounts" name="계정" />
                    <NaviItemLink path="/courses" name="수업" />
                    <NaviItemLink path="/assessments" name="평가" />
                    <NaviItemLink path="/me" name="내 정보" />
                  </Fragment>
                ) : undefined}
                {roler === "student" ? (
                  <Fragment>
                    <NaviItemLink path="/me" name="내 정보" />
                  </Fragment>
                ) : undefined}
              </Fragment>
            ) : undefined}
          </Nav>
          <div className="d-flex">
            {loggedIn ? (
              <Nav.Item>
                <Nav.Link as={Link} to="/logout">
                  로그아웃[{displayName}]
                </Nav.Link>
              </Nav.Item>
            ) : (
              <NaviItemLink path="/login" name="로그인" />
            )}
          </div>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
};

export default TopNavBar;
